import {Text, TextProps} from '@/components/ui/text/Text'
import {createDateTime, formatLocaleDate, getLocalizedDayName} from '@/dayjs'
import {positionToOrdinalNumber} from '@/features/agenda/utils'
import {RepetitionOptions} from '@/features/agenda/types'
import {DayOfWeek} from '@/features/users-availability/types'
import {useTranslation} from '@/translations/i18n'

export const EventRepetitionFrequencyText = ({
    frequency,
    position,
    dayOfWeek,
    date,
    time,
    textProps
}: {
    frequency: RepetitionOptions
    position: number
    dayOfWeek: DayOfWeek
    date?: string
    time?: string
    textProps?: TextProps
}) => {
    const {t} = useTranslation()

    const renderDateAndTimeHint = (date: string, time: string) => {
        return (
            <>
                {` `}
                {t('agenda:time_as_long_as_project', {
                    time: formatLocaleDate(createDateTime(new Date(date), time || '00:00'), 'H:mm')
                })}
            </>
        )
    }

    return (
        <Text palette="neutral" shade="950" weight="500" size="textSm" {...textProps}>
            {frequency == 'weekly'
                ? position < 5
                    ? t('agenda:schedule_weekly_repetition', {
                          day: getLocalizedDayName(dayOfWeek)
                      })
                    : t('agenda:schedule_weekly_repetition_last', {
                          day: getLocalizedDayName(dayOfWeek)
                      })
                : frequency == 'monthly'
                  ? position < 5
                      ? t('agenda:schedule_monthly_repetition', {
                            day: getLocalizedDayName(dayOfWeek),
                            position: t(
                                positionToOrdinalNumber[position as keyof typeof positionToOrdinalNumber]
                            ).toLowerCase()
                        })
                      : t('agenda:schedule_monthly_repetition_last', {
                            day: getLocalizedDayName(dayOfWeek)
                        })
                  : t('agenda:frequency_not_supported')}
            {date && time && renderDateAndTimeHint(date, time)}
        </Text>
    )
}
